// src/data.js
export const positionsData = [
    {
        "_id": "64329c00b7861d7c9172a671",
        "status": 1,
        "name": "Physics",
        "subject": {
            "_id": "641bc373947f5641ae3da1eb",
            "name": "Physics"
        },
        "experience": {
            "_id": "641bd0a0947f5641ae3da3a6",
            "name": "Mains"
        },
        "salary": "15,000/-",
        "worktype": 2,
        "city": "Hyderabad LB Nagar zone",
        "createdAt": "2023-04-09T11:05:36.024Z",
        "updatedAt": "2023-04-09T11:05:36.024Z",
        "__v": 0
    },
    {
        "_id": "64329becb7861d7c9172a65c",
        "status": 1,
        "name": "Maths",
        "subject": {
            "_id": "641bd092947f5641ae3da39e",
            "name": "Maths"
        },
        "experience": {
            "_id": "641bd0a0947f5641ae3da3a6",
            "name": "Mains"
        },
        "salary": "15,000/-",
        "worktype": 2,
        "city": "Hyderabad LB Nagar zone",
        "createdAt": "2023-04-09T11:05:16.730Z",
        "updatedAt": "2023-04-09T11:05:16.730Z",
        "__v": 0
    },
    {
        "_id": "64329bd1b7861d7c9172a647",
        "status": 1,
        "name": "Chemistry",
        "subject": {
            "_id": "641bc3fc947f5641ae3da20b",
            "name": "Chemistry"
        },
        "experience": {
            "_id": "641bd0a0947f5641ae3da3a6",
            "name": "Mains"
        },
        "salary": "15,000/-",
        "worktype": 2,
        "city": "Hyderabad LB Nagar zone",
        "createdAt": "2023-04-09T11:04:49.861Z",
        "updatedAt": "2023-04-09T11:04:49.861Z",
        "__v": 0
    },
    {
        "_id": "642f166ff4270a4c8bec003a",
        "status": 1,
        "name": "Maths ",
        "subject": {
            "_id": "641bd092947f5641ae3da39e",
            "name": "Maths"
        },
        "experience": {
            "_id": "641bd0a0947f5641ae3da3a6",
            "name": "Mains"
        },
        "salary": "12L PA",
        "worktype": 1,
        "city": "Vijayawada ",
        "createdAt": "2023-04-06T18:58:55.618Z",
        "updatedAt": "2023-04-06T18:58:55.618Z",
        "__v": 0
    },
    {
        "_id": "642f1651f4270a4c8bec0025",
        "status": 1,
        "name": "Maths",
        "subject": {
            "_id": "641bd092947f5641ae3da39e",
            "name": "Maths"
        },
        "experience": {
            "_id": "641bd0a0947f5641ae3da3a6",
            "name": "Mains"
        },
        "salary": "8.4L - 9.6L PA",
        "worktype": 1,
        "city": "Banglore",
        "createdAt": "2023-04-06T18:58:25.710Z",
        "updatedAt": "2023-04-06T18:58:25.710Z",
        "__v": 0
    },
    {
        "_id": "642f1630f4270a4c8bec0010",
        "status": 1,
        "name": "Physics ",
        "subject": {
            "_id": "641bc373947f5641ae3da1eb",
            "name": "Physics"
        },
        "experience": {
            "_id": "641bd0a0947f5641ae3da3a6",
            "name": "Mains"
        },
        "salary": "15-16L PA",
        "worktype": 1,
        "city": "Banglore",
        "createdAt": "2023-04-06T18:57:52.733Z",
        "updatedAt": "2023-04-06T18:57:52.734Z",
        "__v": 0
    },
    {
        "_id": "642f1612f4270a4c8bebfffb",
        "status": 1,
        "name": "Maths ",
        "subject": {
            "_id": "641bd092947f5641ae3da39e",
            "name": "Maths"
        },
        "experience": {
            "_id": "641bc4dd947f5641ae3da246",
            "name": "Advance"
        },
        "salary": "17L - 18L PA",
        "worktype": 1,
        "city": "Banglore",
        "createdAt": "2023-04-06T18:57:22.210Z",
        "updatedAt": "2023-04-06T18:57:22.210Z",
        "__v": 0
    },
    {
        "_id": "642f15e3f4270a4c8bebffe6",
        "status": 1,
        "name": "Physics Neet ",
        "subject": {
            "_id": "641bc373947f5641ae3da1eb",
            "name": "Physics"
        },
        "experience": {
            "_id": "641d732b3df34d4442c50f02",
            "name": "NEET"
        },
        "salary": "6L - 7.2L",
        "worktype": 1,
        "city": "Hyderabad ",
        "createdAt": "2023-04-06T18:56:35.924Z",
        "updatedAt": "2023-04-06T18:56:35.924Z",
        "__v": 0
    },
    {
        "_id": "642f15b3f4270a4c8bebffd1",
        "status": 1,
        "name": "Chemistry ",
        "subject": {
            "_id": "641bc3fc947f5641ae3da20b",
            "name": "Chemistry"
        },
        "experience": {
            "_id": "641bd0a0947f5641ae3da3a6",
            "name": "Mains"
        },
        "salary": "6L - 7.2L",
        "worktype": 1,
        "city": "Hyderabad ",
        "createdAt": "2023-04-06T18:55:47.706Z",
        "updatedAt": "2023-04-06T18:55:47.706Z",
        "__v": 0
    },
    {
        "_id": "642f1593f4270a4c8bebffbc",
        "status": 1,
        "name": "Physics ",
        "subject": {
            "_id": "641bc373947f5641ae3da1eb",
            "name": "Physics"
        },
        "experience": {
            "_id": "641bd0a0947f5641ae3da3a6",
            "name": "Mains"
        },
        "salary": "6- 7.2L",
        "worktype": 1,
        "city": "Hyderabad ",
        "createdAt": "2023-04-06T18:55:15.461Z",
        "updatedAt": "2023-04-06T18:55:15.461Z",
        "__v": 0
    },
    {
        "_id": "642f157ff4270a4c8bebffa7",
        "status": 1,
        "name": "Maths ",
        "subject": {
            "_id": "641bd092947f5641ae3da39e",
            "name": "Maths"
        },
        "experience": {
            "_id": "641bd0a0947f5641ae3da3a6",
            "name": "Mains"
        },
        "salary": "6- 7.2L",
        "worktype": 1,
        "city": "Hyderabad ",
        "createdAt": "2023-04-06T18:54:55.639Z",
        "updatedAt": "2023-04-06T18:54:55.639Z",
        "__v": 0
    },
    {
        "_id": "642f1548f4270a4c8bebff92",
        "status": 1,
        "name": "Physics CBSE HOD ",
        "subject": {
            "_id": "641bc373947f5641ae3da1eb",
            "name": "Physics"
        },
        "experience": {
            "_id": "641bd0a0947f5641ae3da3a6",
            "name": "Mains"
        },
        "salary": "10-11L PA",
        "worktype": 1,
        "city": "Hyderabad ",
        "createdAt": "2023-04-06T18:54:00.609Z",
        "updatedAt": "2023-04-06T18:54:00.609Z",
        "__v": 0
    },
    {
        "_id": "642f1525f4270a4c8bebff7d",
        "status": 1,
        "name": "Chemistry HOD ",
        "subject": {
            "_id": "641bc3fc947f5641ae3da20b",
            "name": "Chemistry"
        },
        "experience": {
            "_id": "641bd0a0947f5641ae3da3a6",
            "name": "Mains"
        },
        "salary": "16-17L PA",
        "worktype": 1,
        "city": "Hyderabad ",
        "createdAt": "2023-04-06T18:53:25.296Z",
        "updatedAt": "2023-04-06T18:53:25.296Z",
        "__v": 0
    },
    {
        "_id": "642f14f5f4270a4c8bebff68",
        "status": 1,
        "name": "Physics ",
        "subject": {
            "_id": "641bc373947f5641ae3da1eb",
            "name": "Physics"
        },
        "experience": {
            "_id": "641bd0a0947f5641ae3da3a6",
            "name": "Mains"
        },
        "salary": "15L PA",
        "worktype": 1,
        "city": "Guntur ",
        "createdAt": "2023-04-06T18:52:37.155Z",
        "updatedAt": "2023-04-06T18:52:37.155Z",
        "__v": 0
    },
    {
        "_id": "642f14e8f4270a4c8bebff53",
        "status": 1,
        "name": "Maths ",
        "subject": {
            "_id": "641bd092947f5641ae3da39e",
            "name": "Maths"
        },
        "experience": {
            "_id": "641bd0a0947f5641ae3da3a6",
            "name": "Mains"
        },
        "salary": "15L PA",
        "worktype": 1,
        "city": "Guntur ",
        "createdAt": "2023-04-06T18:52:24.889Z",
        "updatedAt": "2023-04-06T18:52:24.889Z",
        "__v": 0
    },
    {
        "_id": "642f14c1f4270a4c8bebff3e",
        "status": 1,
        "name": "Physics ",
        "subject": {
            "_id": "641bc373947f5641ae3da1eb",
            "name": "Physics"
        },
        "experience": {
            "_id": "641bd0a0947f5641ae3da3a6",
            "name": "Mains"
        },
        "salary": "16-18L PA",
        "worktype": 1,
        "city": "Bellari ",
        "createdAt": "2023-04-06T18:51:45.092Z",
        "updatedAt": "2023-04-06T18:51:45.092Z",
        "__v": 0
    },
    {
        "_id": "642f14abf4270a4c8bebff29",
        "status": 1,
        "name": "Maths ",
        "subject": {
            "_id": "641bd092947f5641ae3da39e",
            "name": "Maths"
        },
        "experience": {
            "_id": "641bd0a0947f5641ae3da3a6",
            "name": "Mains"
        },
        "salary": "16-18L PA",
        "worktype": 1,
        "city": "Bellari ",
        "createdAt": "2023-04-06T18:51:23.956Z",
        "updatedAt": "2023-04-06T18:51:23.956Z",
        "__v": 0
    },
    {
        "_id": "642f1470f4270a4c8bebff14",
        "status": 1,
        "name": "Physics ",
        "subject": {
            "_id": "641bc373947f5641ae3da1eb",
            "name": "Physics"
        },
        "experience": {
            "_id": "641bd0a0947f5641ae3da3a6",
            "name": "Mains"
        },
        "salary": "12-15L PA",
        "worktype": 1,
        "city": "Khammam ",
        "createdAt": "2023-04-06T18:50:24.602Z",
        "updatedAt": "2023-04-06T18:50:24.602Z",
        "__v": 0
    },
    {
        "_id": "642f1461f4270a4c8bebfeff",
        "status": 1,
        "name": "Maths ",
        "subject": {
            "_id": "641bd092947f5641ae3da39e",
            "name": "Maths"
        },
        "experience": {
            "_id": "641bd0a0947f5641ae3da3a6",
            "name": "Mains"
        },
        "salary": "12-15L PA",
        "worktype": 1,
        "city": "Khammam ",
        "createdAt": "2023-04-06T18:50:09.802Z",
        "updatedAt": "2023-04-06T18:50:09.802Z",
        "__v": 0
    },
    {
        "_id": "642f1420f4270a4c8bebfeea",
        "status": 1,
        "name": "Physics ",
        "subject": {
            "_id": "641bc373947f5641ae3da1eb",
            "name": "Physics"
        },
        "experience": {
            "_id": "641d72d53df34d4442c50ed4",
            "name": "IPE/EMCET"
        },
        "salary": "4.8 - 6L PA",
        "worktype": 1,
        "city": "Hyderabad ",
        "createdAt": "2023-04-06T18:49:04.218Z",
        "updatedAt": "2023-04-06T18:49:04.218Z",
        "__v": 0
    },
    {
        "_id": "642f140cf4270a4c8bebfed5",
        "status": 1,
        "name": "Chemistry ",
        "subject": {
            "_id": "641bc3fc947f5641ae3da20b",
            "name": "Chemistry"
        },
        "experience": {
            "_id": "641d72d53df34d4442c50ed4",
            "name": "IPE/EMCET"
        },
        "salary": "4.8 - 6L PA",
        "worktype": 1,
        "city": "Hyderabad ",
        "createdAt": "2023-04-06T18:48:44.171Z",
        "updatedAt": "2023-04-06T18:48:44.171Z",
        "__v": 0
    },
    {
        "_id": "642f1381f4270a4c8bebfea1",
        "status": 1,
        "name": "Chemistry Advance ",
        "subject": {
            "_id": "641bc3fc947f5641ae3da20b",
            "name": "Chemistry"
        },
        "experience": {
            "_id": "641bc4dd947f5641ae3da246",
            "name": "Advance"
        },
        "salary": "25-27L PA",
        "worktype": 1,
        "city": "Hyderabad ",
        "createdAt": "2023-04-06T18:46:25.407Z",
        "updatedAt": "2023-04-06T18:46:25.407Z",
        "__v": 0
    },
    {
        "_id": "642f134ff4270a4c8bebfe8c",
        "status": 1,
        "name": "Maths ",
        "subject": {
            "_id": "641bd092947f5641ae3da39e",
            "name": "Maths"
        },
        "experience": {
            "_id": "641bd0a0947f5641ae3da3a6",
            "name": "Mains"
        },
        "salary": "12-15L PA",
        "worktype": 1,
        "city": "Banglore",
        "createdAt": "2023-04-06T18:45:35.652Z",
        "updatedAt": "2023-04-06T18:45:35.652Z",
        "__v": 0
    },
    {
        "_id": "642f1321f4270a4c8bebfe67",
        "status": 1,
        "name": "Physics Advance ",
        "subject": {
            "_id": "641bc373947f5641ae3da1eb",
            "name": "Physics"
        },
        "experience": {
            "_id": "641bc4dd947f5641ae3da246",
            "name": "Advance"
        },
        "salary": "24-28L PA",
        "worktype": 1,
        "city": "Banglore",
        "createdAt": "2023-04-06T18:44:49.673Z",
        "updatedAt": "2023-04-06T18:44:49.673Z",
        "__v": 0
    },
    {
        "_id": "642f12ebf4270a4c8bebfe3b",
        "status": 1,
        "name": "Chemistry Advance ",
        "subject": {
            "_id": "641bc3fc947f5641ae3da20b",
            "name": "Chemistry"
        },
        "experience": {
            "_id": "641bc4dd947f5641ae3da246",
            "name": "Advance"
        },
        "salary": "34-36L",
        "worktype": 1,
        "city": "Banglore",
        "createdAt": "2023-04-06T18:43:55.529Z",
        "updatedAt": "2023-04-06T18:43:55.529Z",
        "__v": 0
    },
    {
        "_id": "64211d24f4270a4c8bebec47",
        "status": 1,
        "name": "Physics",
        "subject": {
            "_id": "641bc373947f5641ae3da1eb",
            "name": "Physics"
        },
        "experience": {
            "_id": "641d732b3df34d4442c50f02",
            "name": "NEET"
        },
        "salary": "12-15 LPA",
        "worktype": 1,
        "city": "Hyderabad Madhapur zone",
        "createdAt": "2023-03-27T04:35:48.090Z",
        "updatedAt": "2023-03-27T04:35:48.090Z",
        "__v": 0
    },
    {
        "_id": "64201fbb52b69549e8d62aef",
        "status": 1,
        "name": "Botany",
        "subject": {
            "_id": "641d73433df34d4442c50f10",
            "name": "Botany"
        },
        "experience": {
            "_id": "641d5c0d3df34d4442c50c30",
            "name": "Foundation"
        },
        "salary": "60,000 to 75,000",
        "worktype": 1,
        "city": "Pune",
        "createdAt": "2023-03-26T10:34:35.019Z",
        "updatedAt": "2023-03-26T10:34:35.019Z",
        "__v": 0
    },
    {
        "_id": "64201f7052b69549e8d62ada",
        "status": null,
        "name": "Botany",
        "subject": {
            "_id": "641d73433df34d4442c50f10",
            "name": "Botany"
        },
        "experience": {
            "_id": "641d5c373df34d4442c50c3d",
            "name": "CBSE"
        },
        "salary": "35,000 to 40,000",
        "worktype": 1,
        "city": "Rajahmundry",
        "createdAt": "2023-03-26T10:33:20.813Z",
        "updatedAt": "2023-03-26T10:33:20.813Z",
        "__v": 0
    },
    {
        "_id": "64201f0a52b69549e8d62ac5",
        "status": 1,
        "name": "Botany",
        "subject": {
            "_id": "641d73433df34d4442c50f10",
            "name": "Botany"
        },
        "experience": {
            "_id": "641d5c0d3df34d4442c50c30",
            "name": "Foundation"
        },
        "salary": "60,000 to 75,000",
        "worktype": 1,
        "city": "Maharashtra",
        "createdAt": "2023-03-26T10:31:38.680Z",
        "updatedAt": "2023-03-26T10:31:38.680Z",
        "__v": 0
    },
    {
        "_id": "64201ece52b69549e8d62ab0",
        "status": 1,
        "name": "Botany",
        "subject": {
            "_id": "641d73433df34d4442c50f10",
            "name": "Botany"
        },
        "experience": {
            "_id": "641d732b3df34d4442c50f02",
            "name": "NEET"
        },
        "salary": "15-20 LPA",
        "worktype": 1,
        "city": "Maharashtra",
        "createdAt": "2023-03-26T10:30:38.914Z",
        "updatedAt": "2023-03-26T10:30:38.914Z",
        "__v": 0
    },
    {
        "_id": "6420199c52b69549e8d62a71",
        "status": 1,
        "name": "Zoology",
        "subject": {
            "_id": "641d734c3df34d4442c50f17",
            "name": "Zoology"
        },
        "experience": {
            "_id": "641d732b3df34d4442c50f02",
            "name": "NEET"
        },
        "salary": "14 LPA",
        "worktype": 1,
        "city": "Erode",
        "createdAt": "2023-03-26T10:08:28.818Z",
        "updatedAt": "2023-03-26T10:08:28.818Z",
        "__v": 0
    },
    {
        "_id": "6420196552b69549e8d62a5c",
        "status": 1,
        "name": "Botany",
        "subject": {
            "_id": "641d73433df34d4442c50f10",
            "name": "Botany"
        },
        "experience": {
            "_id": "641d732b3df34d4442c50f02",
            "name": "NEET"
        },
        "salary": "22 LPA",
        "worktype": 1,
        "city": "Coimbatore",
        "createdAt": "2023-03-26T10:07:33.416Z",
        "updatedAt": "2023-03-26T10:07:33.416Z",
        "__v": 0
    },
    {
        "_id": "6420193a52b69549e8d62a47",
        "status": 1,
        "name": "Physics",
        "subject": {
            "_id": "641bc373947f5641ae3da1eb",
            "name": "Physics"
        },
        "experience": {
            "_id": "642018f552b69549e8d62a29",
            "name": "Mains/NEET"
        },
        "salary": "15 LPA",
        "worktype": 1,
        "city": "Coimbatore",
        "createdAt": "2023-03-26T10:06:50.771Z",
        "updatedAt": "2023-03-26T10:06:50.771Z",
        "__v": 0
    },
    {
        "_id": "642018ac52b69549e8d62a1c",
        "status": 1,
        "name": "Maths Mid & Sr Faculty",
        "subject": {
            "_id": "641bd092947f5641ae3da39e",
            "name": "Maths"
        },
        "experience": {
            "_id": "641bc4dd947f5641ae3da246",
            "name": "Advance"
        },
        "salary": "15-24 LPA",
        "worktype": 1,
        "city": "Salem & Coimbatore",
        "createdAt": "2023-03-26T10:04:28.825Z",
        "updatedAt": "2023-03-26T10:04:28.825Z",
        "__v": 0
    },
    {
        "_id": "6420185052b69549e8d62a08",
        "status": 1,
        "name": "Chemistry Sr Faculty",
        "subject": {
            "_id": "641bc3fc947f5641ae3da20b",
            "name": "Chemistry"
        },
        "experience": {
            "_id": "641bc4dd947f5641ae3da246",
            "name": "Advance"
        },
        "salary": "28-30 LPA",
        "worktype": 1,
        "city": "Salem & Coimbatore",
        "createdAt": "2023-03-26T10:02:56.226Z",
        "updatedAt": "2023-03-26T10:02:56.226Z",
        "__v": 0
    },
    {
        "_id": "6420183052b69549e8d629f4",
        "status": 1,
        "name": "Physics Sr Faculty",
        "subject": {
            "_id": "641bc373947f5641ae3da1eb",
            "name": "Physics"
        },
        "experience": {
            "_id": "641bc4dd947f5641ae3da246",
            "name": "Advance"
        },
        "salary": "28-30 LPA",
        "worktype": 1,
        "city": "Salem & Coimbatore",
        "createdAt": "2023-03-26T10:02:24.967Z",
        "updatedAt": "2023-03-26T10:02:24.967Z",
        "__v": 0
    },
    {
        "_id": "642015b652b69549e8d629b0",
        "status": null,
        "name": "Physics",
        "subject": {
            "_id": "641bc373947f5641ae3da1eb",
            "name": "Physics"
        },
        "experience": {
            "_id": "641d72d53df34d4442c50ed4",
            "name": "IPE/EMCET"
        },
        "salary": "50,000 to 90,000",
        "worktype": 1,
        "city": "Goa",
        "createdAt": "2023-03-26T09:51:50.859Z",
        "updatedAt": "2023-03-26T09:51:50.859Z",
        "__v": 0
    },
    {
        "_id": "6420159052b69549e8d6299c",
        "status": 1,
        "name": "Chemistry",
        "subject": {
            "_id": "641bc3fc947f5641ae3da20b",
            "name": "Chemistry"
        },
        "experience": {
            "_id": "641d72d53df34d4442c50ed4",
            "name": "IPE/EMCET"
        },
        "salary": "50,000 to 90,000",
        "worktype": 1,
        "city": "Goa",
        "createdAt": "2023-03-26T09:51:12.206Z",
        "updatedAt": "2023-03-26T09:51:12.206Z",
        "__v": 0
    },
    {
        "_id": "641d7c0f3df34d4442c51232",
        "status": 1,
        "name": "Botany",
        "subject": {
            "_id": "641d73433df34d4442c50f10",
            "name": "Botany"
        },
        "experience": {
            "_id": "641d732b3df34d4442c50f02",
            "name": "NEET"
        },
        "salary": "60,000 to 75,000 PM",
        "worktype": 1,
        "city": "Hyderabad",
        "createdAt": "2023-03-24T10:31:43.755Z",
        "updatedAt": "2023-03-24T10:31:43.755Z",
        "__v": 0
    },
    {
        "_id": "641d7bf23df34d4442c5120c",
        "status": null,
        "name": "Botany",
        "subject": {
            "_id": "641d73433df34d4442c50f10",
            "name": "Botany"
        },
        "experience": {
            "_id": "641d732b3df34d4442c50f02",
            "name": "NEET"
        },
        "salary": "15-20 LPA",
        "worktype": 1,
        "city": "Hyderabad",
        "createdAt": "2023-03-24T10:31:14.515Z",
        "updatedAt": "2023-03-24T10:31:14.515Z",
        "__v": 0
    },
    {
        "_id": "641d7bca3df34d4442c511e6",
        "status": 1,
        "name": "Botany",
        "subject": {
            "_id": "641d73433df34d4442c50f10",
            "name": "Botany"
        },
        "experience": {
            "_id": "641d732b3df34d4442c50f02",
            "name": "NEET"
        },
        "salary": "18-19.5 LPA",
        "worktype": 1,
        "city": "Hyderabad",
        "createdAt": "2023-03-24T10:30:34.325Z",
        "updatedAt": "2023-03-24T10:30:34.325Z",
        "__v": 0
    },
    {
        "_id": "641d7ba43df34d4442c511d2",
        "status": 1,
        "name": "Botany",
        "subject": {
            "_id": "641d73433df34d4442c50f10",
            "name": "Botany"
        },
        "experience": {
            "_id": "641d732b3df34d4442c50f02",
            "name": "NEET"
        },
        "salary": "24-33 LPA",
        "worktype": 1,
        "city": "Akola Maharastra",
        "createdAt": "2023-03-24T10:29:56.775Z",
        "updatedAt": "2023-03-24T10:29:56.775Z",
        "__v": 0
    },
    {
        "_id": "641d7b743df34d4442c511be",
        "status": 1,
        "name": "Botany",
        "subject": {
            "_id": "641d73433df34d4442c50f10",
            "name": "Botany"
        },
        "experience": {
            "_id": "641d732b3df34d4442c50f02",
            "name": "NEET"
        },
        "salary": "18-20 LPA",
        "worktype": 1,
        "city": "Aurangabad",
        "createdAt": "2023-03-24T10:29:08.860Z",
        "updatedAt": "2023-03-24T10:29:08.860Z",
        "__v": 0
    },
    {
        "_id": "641d7abd3df34d4442c5115c",
        "status": null,
        "name": "Botany",
        "subject": {
            "_id": "641d73433df34d4442c50f10",
            "name": "Botany"
        },
        "experience": {
            "_id": "641d732b3df34d4442c50f02",
            "name": "NEET"
        },
        "salary": "12 LPA",
        "worktype": 1,
        "city": "Kanapur,Merut,Lucknow",
        "createdAt": "2023-03-24T10:26:05.659Z",
        "updatedAt": "2023-03-24T10:26:05.659Z",
        "__v": 0
    },
    {
        "_id": "641d7a823df34d4442c51148",
        "status": 1,
        "name": "Zoology",
        "subject": {
            "_id": "641d734c3df34d4442c50f17",
            "name": "Zoology"
        },
        "experience": {
            "_id": "641d732b3df34d4442c50f02",
            "name": "NEET"
        },
        "salary": "20 LPA",
        "worktype": 1,
        "city": "Tirupati",
        "createdAt": "2023-03-24T10:25:06.248Z",
        "updatedAt": "2023-03-24T10:25:06.248Z",
        "__v": 0
    },
    {
        "_id": "641d7a583df34d4442c51134",
        "status": 1,
        "name": "Zoology",
        "subject": {
            "_id": "641d734c3df34d4442c50f17",
            "name": "Zoology"
        },
        "experience": {
            "_id": "641d732b3df34d4442c50f02",
            "name": "NEET"
        },
        "salary": "30,000 PM",
        "worktype": 2,
        "city": "Hyderabad LB Nagar Zone",
        "createdAt": "2023-03-24T10:24:24.958Z",
        "updatedAt": "2023-03-24T10:24:24.958Z",
        "__v": 0
    },
    {
        "_id": "641d7a493df34d4442c51120",
        "status": 1,
        "name": "Botany",
        "subject": {
            "_id": "641d73433df34d4442c50f10",
            "name": "Botany"
        },
        "experience": {
            "_id": "641d732b3df34d4442c50f02",
            "name": "NEET"
        },
        "salary": "30,000 PM",
        "worktype": 2,
        "city": "Hyderabad LB Nagar Zone",
        "createdAt": "2023-03-24T10:24:09.199Z",
        "updatedAt": "2023-03-24T10:24:09.199Z",
        "__v": 0
    },
    {
        "_id": "641d77793df34d4442c510bc",
        "status": null,
        "name": "Zoology",
        "subject": {
            "_id": "641d734c3df34d4442c50f17",
            "name": "Zoology"
        },
        "experience": {
            "_id": "641d732b3df34d4442c50f02",
            "name": "NEET"
        },
        "salary": "15-16 LPA",
        "worktype": 1,
        "city": "Bangalore",
        "createdAt": "2023-03-24T10:12:09.429Z",
        "updatedAt": "2023-03-24T10:12:09.429Z",
        "__v": 0
    },
    {
        "_id": "641d77693df34d4442c510a5",
        "status": 1,
        "name": "Zoology",
        "subject": {
            "_id": "641d734c3df34d4442c50f17",
            "name": "Zoology"
        },
        "experience": {
            "_id": "641d732b3df34d4442c50f02",
            "name": "NEET"
        },
        "salary": "15-16 LPA",
        "worktype": 1,
        "city": "Bangalore",
        "createdAt": "2023-03-24T10:11:53.081Z",
        "updatedAt": "2023-03-24T10:11:53.081Z",
        "__v": 0
    },
    {
        "_id": "641d77693df34d4442c510a3",
        "status": 1,
        "name": "Zoology",
        "subject": {
            "_id": "641d734c3df34d4442c50f17",
            "name": "Zoology"
        },
        "experience": {
            "_id": "641d732b3df34d4442c50f02",
            "name": "NEET"
        },
        "salary": "15-16 LPA",
        "worktype": 1,
        "city": "Bangalore",
        "createdAt": "2023-03-24T10:11:53.008Z",
        "updatedAt": "2023-03-24T10:11:53.008Z",
        "__v": 0
    },
    {
        "_id": "641d77303df34d4442c5108f",
        "status": 1,
        "name": "Chemistry",
        "subject": {
            "_id": "641bc3fc947f5641ae3da20b",
            "name": "Chemistry"
        },
        "experience": {
            "_id": "641d732b3df34d4442c50f02",
            "name": "NEET"
        },
        "salary": "80,000 PM",
        "worktype": 1,
        "city": "Gulbarga",
        "createdAt": "2023-03-24T10:10:56.847Z",
        "updatedAt": "2023-03-24T10:10:56.847Z",
        "__v": 0
    },
    {
        "_id": "641d76663df34d4442c5107b",
        "status": 1,
        "name": "Zoology",
        "subject": {
            "_id": "641d734c3df34d4442c50f17",
            "name": "Zoology"
        },
        "experience": {
            "_id": "641d732b3df34d4442c50f02",
            "name": "NEET"
        },
        "salary": "18-20 LPA",
        "worktype": 1,
        "city": "Gangavathi- Karnataka",
        "createdAt": "2023-03-24T10:07:34.208Z",
        "updatedAt": "2023-03-24T10:07:34.208Z",
        "__v": 0
    },
    {
        "_id": "641d76443df34d4442c51067",
        "status": null,
        "name": "Zoology",
        "subject": {
            "_id": "641d734c3df34d4442c50f17",
            "name": "Zoology"
        },
        "experience": {
            "_id": "641d732b3df34d4442c50f02",
            "name": "NEET"
        },
        "salary": "12-18 LPA",
        "worktype": 1,
        "city": "Namakkal- Tamilnadu",
        "createdAt": "2023-03-24T10:07:00.384Z",
        "updatedAt": "2023-03-24T10:07:00.384Z",
        "__v": 0
    },
    {
        "_id": "641d75e53df34d4442c51053",
        "status": 1,
        "name": "Zoology",
        "subject": {
            "_id": "641d734c3df34d4442c50f17",
            "name": "Zoology"
        },
        "experience": {
            "_id": "641d732b3df34d4442c50f02",
            "name": "NEET"
        },
        "salary": "12 LPA",
        "worktype": 1,
        "city": "Kanapur,Merut,Lucknow",
        "createdAt": "2023-03-24T10:05:25.119Z",
        "updatedAt": "2023-03-24T10:05:25.119Z",
        "__v": 0
    },
    {
        "_id": "641d75b13df34d4442c5103f",
        "status": 1,
        "name": "Zoology",
        "subject": {
            "_id": "641d734c3df34d4442c50f17",
            "name": "Zoology"
        },
        "experience": {
            "_id": "641d732b3df34d4442c50f02",
            "name": "NEET"
        },
        "salary": "20 LPA",
        "worktype": 1,
        "city": "Tirupati",
        "createdAt": "2023-03-24T10:04:33.700Z",
        "updatedAt": "2023-03-24T10:04:33.700Z",
        "__v": 0
    },
    {
        "_id": "641d758d3df34d4442c5102b",
        "status": 1,
        "name": "Zoology",
        "subject": {
            "_id": "641d734c3df34d4442c50f17",
            "name": "Zoology"
        },
        "experience": {
            "_id": "641d5c0d3df34d4442c50c30",
            "name": "Foundation"
        },
        "salary": "40,000 to 45,000 PM",
        "worktype": 1,
        "city": "Tamilnadu",
        "createdAt": "2023-03-24T10:03:57.046Z",
        "updatedAt": "2023-03-24T10:03:57.046Z",
        "__v": 0
    },
    {
        "_id": "641d75723df34d4442c51017",
        "status": 1,
        "name": "Zoology",
        "subject": {
            "_id": "641d734c3df34d4442c50f17",
            "name": "Zoology"
        },
        "experience": {
            "_id": "641d732b3df34d4442c50f02",
            "name": "NEET"
        },
        "salary": "10-12 LPA",
        "worktype": 1,
        "city": "Tamilnadu",
        "createdAt": "2023-03-24T10:03:30.158Z",
        "updatedAt": "2023-03-24T10:03:30.158Z",
        "__v": 0
    },
    {
        "_id": "641d75373df34d4442c51003",
        "status": 1,
        "name": "Zoology",
        "subject": {
            "_id": "641d734c3df34d4442c50f17",
            "name": "Zoology"
        },
        "experience": {
            "_id": "641d5c0d3df34d4442c50c30",
            "name": "Foundation"
        },
        "salary": "60,000 to 75,000 PM",
        "worktype": 1,
        "city": "Pune",
        "createdAt": "2023-03-24T10:02:31.992Z",
        "updatedAt": "2023-03-24T10:02:31.992Z",
        "__v": 0
    },
    {
        "_id": "641d75073df34d4442c50fda",
        "status": 1,
        "name": "Zoology",
        "subject": {
            "_id": "641d734c3df34d4442c50f17",
            "name": "Zoology"
        },
        "experience": {
            "_id": "641d5c373df34d4442c50c3d",
            "name": "CBSE"
        },
        "salary": "35,000 PM",
        "worktype": 1,
        "city": "Rajahmundry",
        "createdAt": "2023-03-24T10:01:43.264Z",
        "updatedAt": "2023-03-24T10:01:43.264Z",
        "__v": 0
    },
    {
        "_id": "641d74bf3df34d4442c50fc6",
        "status": 1,
        "name": "Zoology",
        "subject": {
            "_id": "641d734c3df34d4442c50f17",
            "name": "Zoology"
        },
        "experience": {
            "_id": "641d5c373df34d4442c50c3d",
            "name": "CBSE"
        },
        "salary": "35,000 PM",
        "worktype": 1,
        "city": "Ananthapur",
        "createdAt": "2023-03-24T10:00:31.490Z",
        "updatedAt": "2023-03-24T10:00:31.490Z",
        "__v": 0
    },
    {
        "_id": "641d748b3df34d4442c50fb2",
        "status": 1,
        "name": "Zoology",
        "subject": {
            "_id": "641d734c3df34d4442c50f17",
            "name": "Zoology"
        },
        "experience": {
            "_id": "641d5c0d3df34d4442c50c30",
            "name": "Foundation"
        },
        "salary": "60,000 to 75,000 PM",
        "worktype": 1,
        "city": "Maharashtra",
        "createdAt": "2023-03-24T09:59:39.415Z",
        "updatedAt": "2023-03-24T09:59:39.415Z",
        "__v": 0
    },
    {
        "_id": "641d745d3df34d4442c50f9e",
        "status": 1,
        "name": "Zoology",
        "subject": {
            "_id": "641d734c3df34d4442c50f17",
            "name": "Zoology"
        },
        "experience": {
            "_id": "641d732b3df34d4442c50f02",
            "name": "NEET"
        },
        "salary": "15-20 LPA",
        "worktype": 1,
        "city": "Maharashtra",
        "createdAt": "2023-03-24T09:58:53.660Z",
        "updatedAt": "2023-03-24T09:58:53.660Z",
        "__v": 0
    },
    {
        "_id": "641d74323df34d4442c50f8a",
        "status": 1,
        "name": "Zoology",
        "subject": {
            "_id": "641d734c3df34d4442c50f17",
            "name": "Zoology"
        },
        "experience": {
            "_id": "641d732b3df34d4442c50f02",
            "name": "NEET"
        },
        "salary": "18-19.5 LPA",
        "worktype": 1,
        "city": "Hyderabad",
        "createdAt": "2023-03-24T09:58:10.667Z",
        "updatedAt": "2023-03-24T09:58:10.667Z",
        "__v": 0
    },
    {
        "_id": "641d73de3df34d4442c50f76",
        "status": 1,
        "name": "Zoology",
        "subject": {
            "_id": "641d734c3df34d4442c50f17",
            "name": "Zoology"
        },
        "experience": {
            "_id": "641d732b3df34d4442c50f02",
            "name": "NEET"
        },
        "salary": "24-33 LPA",
        "worktype": 1,
        "city": "Akola Maharashtra",
        "createdAt": "2023-03-24T09:56:46.045Z",
        "updatedAt": "2023-03-24T09:56:46.045Z",
        "__v": 0
    },
    {
        "_id": "641d739e3df34d4442c50f4c",
        "status": 1,
        "name": "Zoology",
        "subject": {
            "_id": "641d734c3df34d4442c50f17",
            "name": "Zoology"
        },
        "experience": {
            "_id": "641d732b3df34d4442c50f02",
            "name": "NEET"
        },
        "salary": "18-20 LPA",
        "worktype": 1,
        "city": "Aurangabad",
        "createdAt": "2023-03-24T09:55:42.028Z",
        "updatedAt": "2023-03-24T09:55:42.028Z",
        "__v": 0
    },
    {
        "_id": "641d72fd3df34d4442c50eeb",
        "status": 1,
        "name": "Maths",
        "subject": {
            "_id": "641bd092947f5641ae3da39e",
            "name": "Maths"
        },
        "experience": {
            "_id": "641d72d53df34d4442c50ed4",
            "name": "IPE/EMCET"
        },
        "salary": "50,000 PM",
        "worktype": 1,
        "city": "Hyderabad",
        "createdAt": "2023-03-24T09:53:01.510Z",
        "updatedAt": "2023-03-24T09:53:01.510Z",
        "__v": 0
    },
    {
        "_id": "641d72bc3df34d4442c50ec9",
        "status": 1,
        "name": "Hyderabad",
        "subject": {
            "_id": "641bd092947f5641ae3da39e",
            "name": "Maths"
        },
        "experience": {
            "_id": "641bd0a0947f5641ae3da3a6",
            "name": "Mains"
        },
        "salary": "7-15LPA",
        "worktype": 1,
        "city": "Hyderabad DSNR Zone",
        "createdAt": "2023-03-24T09:51:56.130Z",
        "updatedAt": "2023-03-24T09:51:56.130Z",
        "__v": 0
    },
    {
        "_id": "641d715f3df34d4442c50ea9",
        "status": 1,
        "name": "Maths",
        "subject": {
            "_id": "641bd092947f5641ae3da39e",
            "name": "Maths"
        },
        "experience": {
            "_id": "641bd0a0947f5641ae3da3a6",
            "name": "Mains"
        },
        "salary": "12LPA",
        "worktype": 1,
        "city": "Nellore",
        "createdAt": "2023-03-24T09:46:07.042Z",
        "updatedAt": "2023-03-24T09:46:07.042Z",
        "__v": 0
    },
    {
        "_id": "641d6cbd3df34d4442c50e9a",
        "status": 1,
        "name": "Maths",
        "subject": {
            "_id": "641bd092947f5641ae3da39e",
            "name": "Maths"
        },
        "experience": {
            "_id": "641d5c0d3df34d4442c50c30",
            "name": "Foundation"
        },
        "salary": "30,000 to 50,000 PM",
        "worktype": 1,
        "city": "Hyderabad- Ameerpet",
        "createdAt": "2023-03-24T09:26:21.405Z",
        "updatedAt": "2023-03-24T09:26:21.405Z",
        "__v": 0
    },
    {
        "_id": "641d6c723df34d4442c50e8b",
        "status": 1,
        "name": "Maths",
        "subject": {
            "_id": "641bd092947f5641ae3da39e",
            "name": "Maths"
        },
        "experience": {
            "_id": "641bd0a0947f5641ae3da3a6",
            "name": "Mains"
        },
        "salary": "70,000 PM",
        "worktype": 1,
        "city": "Kodad",
        "createdAt": "2023-03-24T09:25:06.765Z",
        "updatedAt": "2023-03-24T09:25:06.765Z",
        "__v": 0
    },
    {
        "_id": "641d6c283df34d4442c50e7c",
        "status": 1,
        "name": "Maths",
        "subject": {
            "_id": "641bd092947f5641ae3da39e",
            "name": "Maths"
        },
        "experience": {
            "_id": "641d5c0d3df34d4442c50c30",
            "name": "Foundation"
        },
        "salary": "50,000 PM",
        "worktype": 1,
        "city": "Kanapur,Merut,Lucknow",
        "createdAt": "2023-03-24T09:23:52.136Z",
        "updatedAt": "2023-03-24T09:23:52.136Z",
        "__v": 0
    },
    {
        "_id": "641d6bf93df34d4442c50e6d",
        "status": 1,
        "name": "Maths",
        "subject": {
            "_id": "641bd092947f5641ae3da39e",
            "name": "Maths"
        },
        "experience": {
            "_id": "641bd0a0947f5641ae3da3a6",
            "name": "Mains"
        },
        "salary": "12LPA",
        "worktype": 1,
        "city": "Kanapur,Merut,Lucknow",
        "createdAt": "2023-03-24T09:23:05.968Z",
        "updatedAt": "2023-03-24T09:23:05.968Z",
        "__v": 0
    },
    {
        "_id": "641d6ba93df34d4442c50e51",
        "status": 1,
        "name": "Maths",
        "subject": {
            "_id": "641bd092947f5641ae3da39e",
            "name": "Maths"
        },
        "experience": {
            "_id": "641bd0a0947f5641ae3da3a6",
            "name": "Mains"
        },
        "salary": "50,000 PM",
        "worktype": 1,
        "city": "Adoni",
        "createdAt": "2023-03-24T09:21:45.536Z",
        "updatedAt": "2023-03-24T09:21:45.536Z",
        "__v": 0
    },
    {
        "_id": "641d6aec3df34d4442c50e24",
        "status": 1,
        "name": "Maths",
        "subject": {
            "_id": "641bd092947f5641ae3da39e",
            "name": "Maths"
        },
        "experience": {
            "_id": "641bd0a0947f5641ae3da3a6",
            "name": "Mains"
        },
        "salary": "35,000 to 40,000 PM",
        "worktype": 1,
        "city": "Gangavathi- Karnataka",
        "createdAt": "2023-03-24T09:18:36.444Z",
        "updatedAt": "2023-03-24T09:18:36.444Z",
        "__v": 0
    },
    {
        "_id": "641d6a7a3df34d4442c50e15",
        "status": 1,
        "name": "Maths",
        "subject": {
            "_id": "641bd092947f5641ae3da39e",
            "name": "Maths"
        },
        "experience": {
            "_id": "641bd0a0947f5641ae3da3a6",
            "name": "Mains"
        },
        "salary": "70,000 to 80,000 PM",
        "worktype": 1,
        "city": "Warangal",
        "createdAt": "2023-03-24T09:16:42.213Z",
        "updatedAt": "2023-03-24T09:16:42.213Z",
        "__v": 0
    },
    {
        "_id": "641d6a523df34d4442c50e06",
        "status": 1,
        "name": "Maths",
        "subject": {
            "_id": "641bd092947f5641ae3da39e",
            "name": "Maths"
        },
        "experience": {
            "_id": "641d5c0d3df34d4442c50c30",
            "name": "Foundation"
        },
        "salary": "40,000 to 50,000 PM",
        "worktype": 1,
        "city": "Hyderabad",
        "createdAt": "2023-03-24T09:16:02.423Z",
        "updatedAt": "2023-03-24T09:16:02.423Z",
        "__v": 0
    },
    {
        "_id": "641d6a0a3df34d4442c50df7",
        "status": 1,
        "name": "Maths",
        "subject": {
            "_id": "641bd092947f5641ae3da39e",
            "name": "Maths"
        },
        "experience": {
            "_id": "641bd0a0947f5641ae3da3a6",
            "name": "Mains"
        },
        "salary": "14-16 LPA",
        "worktype": 1,
        "city": "Hyderabad Local College",
        "createdAt": "2023-03-24T09:14:50.931Z",
        "updatedAt": "2023-03-24T09:14:50.931Z",
        "__v": 0
    },
    {
        "_id": "641d69c13df34d4442c50de8",
        "status": 1,
        "name": "Maths",
        "subject": {
            "_id": "641bd092947f5641ae3da39e",
            "name": "Maths"
        },
        "experience": {
            "_id": "641bd0a0947f5641ae3da3a6",
            "name": "Mains"
        },
        "salary": "18-20 LPA",
        "worktype": 1,
        "city": "Vizag",
        "createdAt": "2023-03-24T09:13:37.589Z",
        "updatedAt": "2023-03-24T09:13:37.589Z",
        "__v": 0
    },
    {
        "_id": "641d69483df34d4442c50dd9",
        "status": 1,
        "name": "Maths",
        "subject": {
            "_id": "641bd092947f5641ae3da39e",
            "name": "Maths"
        },
        "experience": {
            "_id": "641bd0a0947f5641ae3da3a6",
            "name": "Mains"
        },
        "salary": "12 LPA",
        "worktype": 1,
        "city": "Bhimavaram",
        "createdAt": "2023-03-24T09:11:36.296Z",
        "updatedAt": "2023-03-24T09:11:36.296Z",
        "__v": 0
    },
    {
        "_id": "641d68d73df34d4442c50dca",
        "status": 1,
        "name": "Maths",
        "subject": {
            "_id": "641bd092947f5641ae3da39e",
            "name": "Maths"
        },
        "experience": {
            "_id": "641bd0a0947f5641ae3da3a6",
            "name": "Mains"
        },
        "salary": "10-20 LPA",
        "worktype": 1,
        "city": "Tirupati",
        "createdAt": "2023-03-24T09:09:43.004Z",
        "updatedAt": "2023-03-24T09:09:43.004Z",
        "__v": 0
    },
    {
        "_id": "641d60973df34d4442c50da4",
        "status": 1,
        "name": "Maths ",
        "subject": {
            "_id": "641bd092947f5641ae3da39e",
            "name": "Maths"
        },
        "experience": {
            "_id": "641bd0a0947f5641ae3da3a6",
            "name": "Mains"
        },
        "salary": "12L PA",
        "worktype": 1,
        "city": "Hyderabad Bachupally Zone",
        "createdAt": "2023-03-24T08:34:31.527Z",
        "updatedAt": "2023-03-24T08:34:31.527Z",
        "__v": 0
    },
    {
        "_id": "641d604e3df34d4442c50d95",
        "status": 1,
        "name": "Maths ",
        "subject": {
            "_id": "641bd092947f5641ae3da39e",
            "name": "Maths"
        },
        "experience": {
            "_id": "641bd0a0947f5641ae3da3a6",
            "name": "Mains"
        },
        "salary": "12-15L PA",
        "worktype": 1,
        "city": "Vijayawada",
        "createdAt": "2023-03-24T08:33:18.158Z",
        "updatedAt": "2023-03-24T08:33:18.158Z",
        "__v": 0
    },
    {
        "_id": "641d600b3df34d4442c50d86",
        "status": 1,
        "name": "Maths",
        "subject": {
            "_id": "641bd092947f5641ae3da39e",
            "name": "Maths"
        },
        "experience": {
            "_id": "641d5c373df34d4442c50c3d",
            "name": "CBSE"
        },
        "salary": "40,000 to 45,000 PM",
        "worktype": 1,
        "city": "Tamilnadu",
        "createdAt": "2023-03-24T08:32:11.303Z",
        "updatedAt": "2023-03-24T08:32:11.303Z",
        "__v": 0
    },
    {
        "_id": "641d5fc03df34d4442c50d77",
        "status": 1,
        "name": "Maths",
        "subject": {
            "_id": "641bd092947f5641ae3da39e",
            "name": "Maths"
        },
        "experience": {
            "_id": "641bd0a0947f5641ae3da3a6",
            "name": "Mains"
        },
        "salary": "12L PA",
        "worktype": 1,
        "city": "Tamilnadu",
        "createdAt": "2023-03-24T08:30:56.311Z",
        "updatedAt": "2023-03-24T08:30:56.311Z",
        "__v": 0
    },
    {
        "_id": "641d5f593df34d4442c50d68",
        "status": 1,
        "name": "Maths",
        "subject": {
            "_id": "641bd092947f5641ae3da39e",
            "name": "Maths"
        },
        "experience": {
            "_id": "641bd0a0947f5641ae3da3a6",
            "name": "Mains"
        },
        "salary": "12-18L PA",
        "worktype": 1,
        "city": "Karnataka Zone",
        "createdAt": "2023-03-24T08:29:13.571Z",
        "updatedAt": "2023-03-24T08:29:13.571Z",
        "__v": 0
    },
    {
        "_id": "641d5f253df34d4442c50d59",
        "status": 1,
        "name": "Maths",
        "subject": {
            "_id": "641bd092947f5641ae3da39e",
            "name": "Maths"
        },
        "experience": {
            "_id": "641d5c0d3df34d4442c50c30",
            "name": "Foundation"
        },
        "salary": "60,000 to 75,000 PM",
        "worktype": 1,
        "city": "Pune",
        "createdAt": "2023-03-24T08:28:21.855Z",
        "updatedAt": "2023-03-24T08:28:21.855Z",
        "__v": 0
    },
    {
        "_id": "641d5efa3df34d4442c50d4a",
        "status": 1,
        "name": "Maths",
        "subject": {
            "_id": "641bd092947f5641ae3da39e",
            "name": "Maths"
        },
        "experience": {
            "_id": "641d5c0d3df34d4442c50c30",
            "name": "Foundation"
        },
        "salary": "45,000 PM",
        "worktype": 1,
        "city": "Rajahmundry",
        "createdAt": "2023-03-24T08:27:38.858Z",
        "updatedAt": "2023-03-24T08:27:38.858Z",
        "__v": 0
    },
    {
        "_id": "641d5eaa3df34d4442c50d3b",
        "status": 1,
        "name": "Maths",
        "subject": {
            "_id": "641bd092947f5641ae3da39e",
            "name": "Maths"
        },
        "experience": {
            "_id": "641d5c0d3df34d4442c50c30",
            "name": "Foundation"
        },
        "salary": "35,000 to 45,000 PM",
        "worktype": 1,
        "city": "Mumbai",
        "createdAt": "2023-03-24T08:26:18.819Z",
        "updatedAt": "2023-03-24T08:26:18.819Z",
        "__v": 0
    },
    {
        "_id": "641d5e7c3df34d4442c50d15",
        "status": 1,
        "name": "Maths",
        "subject": {
            "_id": "641bd092947f5641ae3da39e",
            "name": "Maths"
        },
        "experience": {
            "_id": "641bd0a0947f5641ae3da3a6",
            "name": "Mains"
        },
        "salary": "16-17L PA",
        "worktype": 1,
        "city": "Bangalore",
        "createdAt": "2023-03-24T08:25:32.374Z",
        "updatedAt": "2023-03-24T08:25:32.374Z",
        "__v": 0
    },
    {
        "_id": "641d5e393df34d4442c50d06",
        "status": 1,
        "name": "Maths",
        "subject": {
            "_id": "641bd092947f5641ae3da39e",
            "name": "Maths"
        },
        "experience": {
            "_id": "641d5c1e3df34d4442c50c36",
            "name": "E-Techno"
        },
        "salary": "30,000 PM",
        "worktype": 1,
        "city": "Chittor & Madanapally",
        "createdAt": "2023-03-24T08:24:25.551Z",
        "updatedAt": "2023-03-24T08:24:25.551Z",
        "__v": 0
    },
    {
        "_id": "641d5e0f3df34d4442c50cf7",
        "status": 1,
        "name": "Maths",
        "subject": {
            "_id": "641bd092947f5641ae3da39e",
            "name": "Maths"
        },
        "experience": {
            "_id": "641d5c0d3df34d4442c50c30",
            "name": "Foundation"
        },
        "salary": "35,000 PM",
        "worktype": 1,
        "city": "Vizag",
        "createdAt": "2023-03-24T08:23:43.764Z",
        "updatedAt": "2023-03-24T08:23:43.764Z",
        "__v": 0
    },
    {
        "_id": "641d5de23df34d4442c50cdb",
        "status": 1,
        "name": "Maths",
        "subject": {
            "_id": "641bd092947f5641ae3da39e",
            "name": "Maths"
        },
        "experience": {
            "_id": "641d5c0d3df34d4442c50c30",
            "name": "Foundation"
        },
        "salary": "6L",
        "worktype": 1,
        "city": "Hyderabad Bowenpallay zone",
        "createdAt": "2023-03-24T08:22:58.997Z",
        "updatedAt": "2023-03-24T08:22:58.997Z",
        "__v": 0
    },
    {
        "_id": "641d5d633df34d4442c50cbf",
        "status": 1,
        "name": "Maths",
        "subject": {
            "_id": "641bd092947f5641ae3da39e",
            "name": "Maths"
        },
        "experience": {
            "_id": "641d5c0d3df34d4442c50c30",
            "name": "Foundation"
        },
        "salary": "8.4L",
        "worktype": 1,
        "city": "Kadapa",
        "createdAt": "2023-03-24T08:20:51.162Z",
        "updatedAt": "2023-03-24T08:20:51.162Z",
        "__v": 0
    },
    {
        "_id": "641d5d153df34d4442c50ca6",
        "status": 1,
        "name": "Maths",
        "subject": {
            "_id": "641bd092947f5641ae3da39e",
            "name": "Maths"
        },
        "experience": {
            "_id": "641d5c0d3df34d4442c50c30",
            "name": "Foundation"
        },
        "salary": "30,000 PM",
        "worktype": 1,
        "city": "Hyderabad Narayanguda",
        "createdAt": "2023-03-24T08:19:33.200Z",
        "updatedAt": "2023-03-24T08:19:33.200Z",
        "__v": 0
    },
    {
        "_id": "641d5cad3df34d4442c50c61",
        "status": 1,
        "name": "Maths",
        "subject": {
            "_id": "641bd092947f5641ae3da39e",
            "name": "Maths"
        },
        "experience": {
            "_id": "641d5c0d3df34d4442c50c30",
            "name": "Foundation"
        },
        "salary": "60,000 to 75,000",
        "worktype": 1,
        "city": "Maharashtra",
        "createdAt": "2023-03-24T08:17:49.794Z",
        "updatedAt": "2023-03-24T08:17:49.794Z",
        "__v": 0
    },
    {
        "_id": "641d5cad3df34d4442c50c5f",
        "status": 1,
        "name": "Maths",
        "subject": {
            "_id": "641bd092947f5641ae3da39e",
            "name": "Maths"
        },
        "experience": {
            "_id": "641d5c0d3df34d4442c50c30",
            "name": "Foundation"
        },
        "salary": "60,000 to 75,000",
        "worktype": 1,
        "city": "Maharashtra",
        "createdAt": "2023-03-24T08:17:49.532Z",
        "updatedAt": "2023-03-24T08:17:49.532Z",
        "__v": 0
    },
    {
        "_id": "641d5bec3df34d4442c50c28",
        "status": 1,
        "name": "Maths",
        "subject": {
            "_id": "641bd092947f5641ae3da39e",
            "name": "Maths"
        },
        "experience": {
            "_id": "641bd0a0947f5641ae3da3a6",
            "name": "Mains"
        },
        "salary": "12L",
        "worktype": 1,
        "city": "Chittor & Madanapally",
        "createdAt": "2023-03-24T08:14:36.067Z",
        "updatedAt": "2023-03-24T08:14:36.067Z",
        "__v": 0
    },
    {
        "_id": "641c96bd3df34d4442c508fc",
        "status": 1,
        "name": "Maths",
        "subject": {
            "_id": "641bd092947f5641ae3da39e",
            "name": "Maths"
        },
        "experience": {
            "_id": "641bd0a0947f5641ae3da3a6",
            "name": "Mains"
        },
        "salary": "10-11L PA",
        "worktype": 1,
        "city": "Haryana",
        "createdAt": "2023-03-23T18:13:17.423Z",
        "updatedAt": "2023-03-23T18:13:17.423Z",
        "__v": 0
    },
    {
        "_id": "641c967c3df34d4442c508e9",
        "status": 1,
        "name": "Maths",
        "subject": {
            "_id": "641bd092947f5641ae3da39e",
            "name": "Maths"
        },
        "experience": {
            "_id": "641bd0a0947f5641ae3da3a6",
            "name": "Mains"
        },
        "salary": "15-18L PA",
        "worktype": 1,
        "city": "Maharashtra",
        "createdAt": "2023-03-23T18:12:12.917Z",
        "updatedAt": "2023-03-23T18:12:12.917Z",
        "__v": 0
    },
    {
        "_id": "641bff10947f5641ae3db440",
        "status": null,
        "name": "Chemistry",
        "subject": {
            "_id": "641bc3fc947f5641ae3da20b",
            "name": "Chemistry"
        },
        "experience": {
            "_id": "641bc4dd947f5641ae3da246",
            "name": "Advance"
        },
        "salary": "16-18L PA",
        "worktype": 1,
        "createdAt": "2023-03-23T07:26:08.518Z",
        "updatedAt": "2023-03-23T07:26:08.518Z",
        "__v": 0,
        "city": "hyderabad kphb zone"
    },
    {
        "_id": "641bfed3947f5641ae3db3a1",
        "status": null,
        "name": "Chemistry",
        "subject": {
            "_id": "641bc3fc947f5641ae3da20b",
            "name": "Chemistry"
        },
        "experience": {
            "_id": "641bc4dd947f5641ae3da246",
            "name": "Advance"
        },
        "salary": "18L PA",
        "worktype": 1,
        "createdAt": "2023-03-23T07:25:07.338Z",
        "updatedAt": "2023-03-23T07:25:07.338Z",
        "__v": 0,
        "city": "hyderabad-myp zone"
    },
    {
        "_id": "641bfe9a947f5641ae3db35c",
        "status": null,
        "name": "Chemistry",
        "subject": {
            "_id": "641bc3fc947f5641ae3da20b",
            "name": "Chemistry"
        },
        "experience": {
            "_id": "641bd0a0947f5641ae3da3a6",
            "name": "Mains"
        },
        "salary": "12-14L PA",
        "worktype": 1,
        "createdAt": "2023-03-23T07:24:10.306Z",
        "updatedAt": "2023-03-23T07:24:10.306Z",
        "__v": 0,
        "city": "nellore"
    },
    {
        "_id": "641bfe53947f5641ae3db317",
        "status": null,
        "name": "Chemistry",
        "subject": {
            "_id": "641bc3fc947f5641ae3da20b",
            "name": "Chemistry"
        },
        "experience": {
            "_id": "641bc4dd947f5641ae3da246",
            "name": "Advance"
        },
        "salary": "12-20L PA",
        "worktype": 1,
        "createdAt": "2023-03-23T07:22:59.671Z",
        "updatedAt": "2023-03-23T07:22:59.671Z",
        "__v": 0,
        "city": "bangalore"
    },
    {
        "_id": "641bfe0d947f5641ae3db2aa",
        "status": null,
        "name": "Chemistry",
        "subject": {
            "_id": "641bc3fc947f5641ae3da20b",
            "name": "Chemistry"
        },
        "experience": {
            "_id": "641bc4dd947f5641ae3da246",
            "name": "Advance"
        },
        "salary": "18-24L PA",
        "worktype": 1,
        "createdAt": "2023-03-23T07:21:49.522Z",
        "updatedAt": "2023-03-23T07:21:49.522Z",
        "__v": 0,
        "city": "hyderabad-uppal zone"
    },
    {
        "_id": "641bfddb947f5641ae3db297",
        "status": null,
        "name": "Chemistry",
        "subject": {
            "_id": "641bc3fc947f5641ae3da20b",
            "name": "Chemistry"
        },
        "experience": {
            "_id": "641bc4dd947f5641ae3da246",
            "name": "Advance"
        },
        "salary": "12-24L PA",
        "worktype": 1,
        "createdAt": "2023-03-23T07:20:59.710Z",
        "updatedAt": "2023-03-23T07:20:59.710Z",
        "__v": 0,
        "city": "hyderabad non narayana & chaitanya"
    },
    {
        "_id": "641bfd30947f5641ae3db20c",
        "status": null,
        "name": "Chemistry",
        "subject": {
            "_id": "641bc3fc947f5641ae3da20b",
            "name": "Chemistry"
        },
        "experience": {
            "_id": "641bc4dd947f5641ae3da246",
            "name": "Advance"
        },
        "salary": "20-25L PA",
        "worktype": 1,
        "createdAt": "2023-03-23T07:18:08.213Z",
        "updatedAt": "2023-03-23T07:18:08.213Z",
        "__v": 0,
        "city": "tirupati"
    },
    {
        "_id": "641bfd04947f5641ae3db1f9",
        "status": null,
        "name": "Chemistry",
        "subject": {
            "_id": "641bc3fc947f5641ae3da20b",
            "name": "Chemistry"
        },
        "experience": {
            "_id": "641bc4dd947f5641ae3da246",
            "name": "Advance"
        },
        "salary": "18L",
        "worktype": 1,
        "createdAt": "2023-03-23T07:17:24.875Z",
        "updatedAt": "2023-03-23T07:17:24.875Z",
        "__v": 0,
        "city": "vijayawada & guntur"
    },
    {
        "_id": "641bfcd8947f5641ae3db150",
        "status": null,
        "name": "Chemistry",
        "subject": {
            "_id": "641bc3fc947f5641ae3da20b",
            "name": "Chemistry"
        },
        "experience": {
            "_id": "641bc4dd947f5641ae3da246",
            "name": "Advance"
        },
        "salary": "24-30L PA",
        "worktype": 1,
        "createdAt": "2023-03-23T07:16:40.570Z",
        "updatedAt": "2023-03-23T07:16:40.570Z",
        "__v": 0,
        "city": "karnataka"
    },
    {
        "_id": "641bfc9a947f5641ae3db129",
        "status": null,
        "name": "Chemistry",
        "subject": {
            "_id": "641bc3fc947f5641ae3da20b",
            "name": "Chemistry"
        },
        "experience": {
            "_id": "641bc4dd947f5641ae3da246",
            "name": "Advance"
        },
        "salary": "18-20L PA",
        "worktype": 1,
        "createdAt": "2023-03-23T07:15:38.468Z",
        "updatedAt": "2023-03-23T07:15:38.468Z",
        "__v": 0,
        "city": "aurangabad"
    },
    {
        "_id": "641bd654947f5641ae3da58a",
        "status": null,
        "name": "Physics",
        "subject": {
            "_id": "641bc373947f5641ae3da1eb",
            "name": "Physics"
        },
        "experience": {
            "_id": "641bc4dd947f5641ae3da246",
            "name": "Advance"
        },
        "salary": "18L",
        "worktype": 1,
        "createdAt": "2023-03-23T04:32:20.608Z",
        "updatedAt": "2023-03-23T04:32:20.608Z",
        "__v": 0,
        "city": "hyderabad-myplocal clg"
    },
    {
        "_id": "641bd61d947f5641ae3da577",
        "status": null,
        "name": "Physics",
        "subject": {
            "_id": "641bc373947f5641ae3da1eb",
            "name": "Physics"
        },
        "experience": {
            "_id": "641bd0a0947f5641ae3da3a6",
            "name": "Mains"
        },
        "salary": "12-15L PA",
        "worktype": 1,
        "createdAt": "2023-03-23T04:31:25.287Z",
        "updatedAt": "2023-03-23T04:31:25.287Z",
        "__v": 0,
        "city": "nellore"
    },
    {
        "_id": "641bd5e3947f5641ae3da564",
        "status": null,
        "name": "Physics",
        "subject": {
            "_id": "641bc373947f5641ae3da1eb",
            "name": "Physics"
        },
        "experience": {
            "_id": "641bc4dd947f5641ae3da246",
            "name": "Advance"
        },
        "salary": "18-24L PA",
        "worktype": 1,
        "createdAt": "2023-03-23T04:30:27.814Z",
        "updatedAt": "2023-03-23T04:30:27.814Z",
        "__v": 0,
        "city": "hyderabad-uppal zone"
    },
    {
        "_id": "641bd5ab947f5641ae3da551",
        "status": null,
        "name": "Hyderabad",
        "subject": {
            "_id": "641bc373947f5641ae3da1eb",
            "name": "Physics"
        },
        "experience": {
            "_id": "641bc4dd947f5641ae3da246",
            "name": "Advance"
        },
        "salary": "15-21L PA",
        "worktype": 1,
        "createdAt": "2023-03-23T04:29:31.168Z",
        "updatedAt": "2023-03-23T04:29:31.168Z",
        "__v": 0,
        "city": "local college"
    },
    {
        "_id": "641bd563947f5641ae3da53e",
        "status": null,
        "name": "Physics",
        "subject": {
            "_id": "641bc373947f5641ae3da1eb",
            "name": "Physics"
        },
        "experience": {
            "_id": "641bc4dd947f5641ae3da246",
            "name": "Advance"
        },
        "salary": "20-25L PA",
        "worktype": 1,
        "createdAt": "2023-03-23T04:28:19.474Z",
        "updatedAt": "2023-03-23T04:28:19.474Z",
        "__v": 0,
        "city": "tirupati"
    },
    {
        "_id": "641bd538947f5641ae3da52b",
        "status": null,
        "name": "Physics",
        "subject": {
            "_id": "641bc373947f5641ae3da1eb",
            "name": "Physics"
        },
        "experience": {
            "_id": "641bc4dd947f5641ae3da246",
            "name": "Advance"
        },
        "salary": "18L PA",
        "worktype": 1,
        "createdAt": "2023-03-23T04:27:36.608Z",
        "updatedAt": "2023-03-23T04:27:36.608Z",
        "__v": 0,
        "city": "vijayawada"
    },
    {
        "_id": "641bd4f6947f5641ae3da518",
        "status": null,
        "name": "Physics",
        "subject": {
            "_id": "641bc373947f5641ae3da1eb",
            "name": "Physics"
        },
        "experience": {
            "_id": "641bc4dd947f5641ae3da246",
            "name": "Advance"
        },
        "salary": "24-30L PA",
        "worktype": 1,
        "createdAt": "2023-03-23T04:26:30.993Z",
        "updatedAt": "2023-03-23T04:26:30.993Z",
        "__v": 0,
        "city": "karnataka"
    },
    {
        "_id": "641bd4b6947f5641ae3da505",
        "status": null,
        "name": "Physics",
        "subject": {
            "_id": "641bc373947f5641ae3da1eb",
            "name": "Physics"
        },
        "experience": {
            "_id": "641bc4dd947f5641ae3da246",
            "name": "Advance"
        },
        "salary": "18-20L PA",
        "worktype": 1,
        "createdAt": "2023-03-23T04:25:26.817Z",
        "updatedAt": "2023-03-23T04:25:26.817Z",
        "__v": 0,
        "city": "aurangabad"
    },
    {
        "_id": "641bd483947f5641ae3da4f2",
        "status": null,
        "name": "Physics",
        "subject": {
            "_id": "641bc373947f5641ae3da1eb",
            "name": "Physics"
        },
        "experience": {
            "_id": "641bc4dd947f5641ae3da246",
            "name": "Advance"
        },
        "salary": "36-40L PA",
        "worktype": 1,
        "createdAt": "2023-03-23T04:24:35.538Z",
        "updatedAt": "2023-03-23T04:24:35.538Z",
        "__v": 0,
        "city": "vizag senior faculty"
    },
    {
        "_id": "641bd406947f5641ae3da4cb",
        "status": null,
        "name": "Maths",
        "subject": {
            "_id": "641bd092947f5641ae3da39e",
            "name": "Maths"
        },
        "experience": {
            "_id": "641bc4dd947f5641ae3da246",
            "name": "Advance"
        },
        "salary": "18-20L PA",
        "worktype": 1,
        "createdAt": "2023-03-23T04:22:30.219Z",
        "updatedAt": "2023-03-23T04:22:30.219Z",
        "__v": 0,
        "city": "aurangabad"
    },
    {
        "_id": "641bd370947f5641ae3da453",
        "status": null,
        "name": "Maths",
        "subject": {
            "_id": "641bd092947f5641ae3da39e",
            "name": "Maths"
        },
        "experience": {
            "_id": "641bc4dd947f5641ae3da246",
            "name": "Advance"
        },
        "salary": "18-19L PA",
        "worktype": 1,
        "createdAt": "2023-03-23T04:20:00.025Z",
        "updatedAt": "2023-03-23T04:20:00.025Z",
        "__v": 0,
        "city": "rajahmundry"
    },
    {
        "_id": "641bd31c947f5641ae3da440",
        "status": null,
        "name": "Maths",
        "subject": {
            "_id": "641bd092947f5641ae3da39e",
            "name": "Maths"
        },
        "experience": {
            "_id": "641bc4dd947f5641ae3da246",
            "name": "Advance"
        },
        "salary": "24-30L PA",
        "worktype": 1,
        "createdAt": "2023-03-23T04:18:36.938Z",
        "updatedAt": "2023-03-23T04:18:36.938Z",
        "__v": 0,
        "city": "karnataka"
    },
    {
        "_id": "641bd2da947f5641ae3da42d",
        "status": null,
        "name": "Maths",
        "subject": {
            "_id": "641bd092947f5641ae3da39e",
            "name": "Maths"
        },
        "experience": {
            "_id": "641bc4dd947f5641ae3da246",
            "name": "Advance"
        },
        "salary": "18L PA",
        "worktype": 1,
        "createdAt": "2023-03-23T04:17:30.293Z",
        "updatedAt": "2023-03-23T04:17:30.293Z",
        "__v": 0,
        "city": "guntur"
    },
    {
        "_id": "641bd2bf947f5641ae3da41a",
        "status": null,
        "name": "Maths",
        "subject": {
            "_id": "641bd092947f5641ae3da39e",
            "name": "Maths"
        },
        "experience": {
            "_id": "641bc4dd947f5641ae3da246",
            "name": "Advance"
        },
        "salary": "18L PA",
        "worktype": 1,
        "createdAt": "2023-03-23T04:17:03.664Z",
        "updatedAt": "2023-03-23T04:17:03.664Z",
        "__v": 0,
        "city": "vijayawada"
    },
    {
        "_id": "641bd28e947f5641ae3da407",
        "status": null,
        "name": "Maths",
        "subject": {
            "_id": "641bd092947f5641ae3da39e",
            "name": "Maths"
        },
        "experience": {
            "_id": "641bc4dd947f5641ae3da246",
            "name": "Advance"
        },
        "salary": "20-25L PA",
        "worktype": 1,
        "createdAt": "2023-03-23T04:16:14.277Z",
        "updatedAt": "2023-03-23T04:16:14.277Z",
        "__v": 0,
        "city": "tirupati"
    },
    {
        "_id": "641bd20f947f5641ae3da3f4",
        "status": null,
        "name": "Maths",
        "subject": {
            "_id": "641bd092947f5641ae3da39e",
            "name": "Maths"
        },
        "experience": {
            "_id": "641bc4dd947f5641ae3da246",
            "name": "Advance"
        },
        "salary": "25L PA",
        "worktype": 1,
        "createdAt": "2023-03-23T04:14:07.312Z",
        "updatedAt": "2023-03-23T04:14:07.312Z",
        "__v": 0,
        "city": "kodad"
    },
    {
        "_id": "641bd1c3947f5641ae3da3e1",
        "status": null,
        "name": "Maths",
        "subject": {
            "_id": "641bd092947f5641ae3da39e",
            "name": "Maths"
        },
        "experience": {
            "_id": "641bc4dd947f5641ae3da246",
            "name": "Advance"
        },
        "salary": "15-18L PA",
        "worktype": 1,
        "createdAt": "2023-03-23T04:12:51.780Z",
        "updatedAt": "2023-03-23T04:12:51.780Z",
        "__v": 0,
        "city": "hyderabad-non narayana & chaitanya"
    },
    {
        "_id": "641bd16c947f5641ae3da3ce",
        "status": null,
        "name": "Maths",
        "subject": {
            "_id": "641bd092947f5641ae3da39e",
            "name": "Maths"
        },
        "experience": {
            "_id": "641bc4dd947f5641ae3da246",
            "name": "Advance"
        },
        "salary": "18-24L PA",
        "worktype": 1,
        "createdAt": "2023-03-23T04:11:24.085Z",
        "updatedAt": "2023-03-23T04:11:24.085Z",
        "__v": 0,
        "city": "hyderabad-uppal zone"
    },
    {
        "_id": "641bd0db947f5641ae3da3b5",
        "status": null,
        "name": "Maths",
        "subject": {
            "_id": "641bd092947f5641ae3da39e",
            "name": "Maths"
        },
        "experience": {
            "_id": "641bc4dd947f5641ae3da246",
            "name": "Advance"
        },
        "salary": "18L PA",
        "worktype": 1,
        "createdAt": "2023-03-23T04:08:59.653Z",
        "updatedAt": "2023-03-23T04:08:59.653Z",
        "__v": 0,
        "city": "hyderabad-myp"
    },
    {
        "_id": "641bc63d947f5641ae3da293",
        "status": null,
        "name": "Chemistry",
        "subject": {
            "_id": "641bc3fc947f5641ae3da20b",
            "name": "Chemistry"
        },
        "experience": {
            "_id": "641bc4dd947f5641ae3da246",
            "name": "Advance"
        },
        "salary": "16-18L PA",
        "worktype": 1,
        "createdAt": "2023-03-23T03:23:41.130Z",
        "updatedAt": "2023-03-23T03:23:41.130Z",
        "__v": 0,
        "city": "hyderabad"
    },
    {
        "_id": "641bc509947f5641ae3da255",
        "status": null,
        "name": "Physics",
        "subject": {
            "_id": "641bc373947f5641ae3da1eb",
            "name": "Physics"
        },
        "experience": {
            "_id": "641bc4dd947f5641ae3da246",
            "name": "Advance"
        },
        "salary": "16-18L PA",
        "worktype": 1,
        "createdAt": "2023-03-23T03:18:33.420Z",
        "updatedAt": "2023-03-23T03:18:33.420Z",
        "__v": 0,
        "city": "hyderabad"
    }
]

export const subjectsData = [
    {
        "name": "Biology",
        "_id": "6537e9cdd2a1e405291302ab",
        "createdAt": "2023-10-24T15:59:10.007Z",
        "updatedAt": "2023-10-24T15:59:10.007Z",
        "__v": 0,
        "positionCount": 0
    },
    {
        "name": "English",
        "_id": "641d736a3df34d4442c50f1f",
        "createdAt": "2023-03-24T09:54:50.190Z",
        "updatedAt": "2023-03-24T09:54:50.190Z",
        "__v": 0,
        "positionCount": 0
    },
    {
        "name": "Zoology",
        "_id": "641d734c3df34d4442c50f17",
        "createdAt": "2023-03-24T09:54:20.127Z",
        "updatedAt": "2023-03-24T09:54:20.127Z",
        "__v": 0,
        "positionCount": 20
    },
    {
        "name": "Botany",
        "_id": "641d73433df34d4442c50f10",
        "createdAt": "2023-03-24T09:54:11.880Z",
        "updatedAt": "2023-03-24T09:54:11.880Z",
        "__v": 0,
        "positionCount": 12
    },
    {
        "name": "Maths",
        "_id": "641bd092947f5641ae3da39e",
        "createdAt": "2023-03-23T04:07:46.173Z",
        "updatedAt": "2023-03-23T04:07:46.173Z",
        "__v": 0,
        "positionCount": 54
    },
    {
        "name": "Chemistry",
        "_id": "641bc3fc947f5641ae3da20b",
        "createdAt": "2023-03-23T03:14:04.130Z",
        "updatedAt": "2023-03-23T03:14:04.130Z",
        "__v": 0,
        "positionCount": 20
    },
    {
        "name": "Physics",
        "_id": "641bc373947f5641ae3da1eb",
        "createdAt": "2023-03-23T03:11:47.545Z",
        "updatedAt": "2023-03-23T03:11:47.545Z",
        "__v": 0,
        "positionCount": 24
    }
]

export const experiencesData = [
    {
        "name": "Mains/NEET",
        "_id": "642018f552b69549e8d62a29",
        "createdAt": "2023-03-26T10:05:41.789Z",
        "updatedAt": "2023-03-26T10:05:41.789Z",
        "__v": 0,
        "positionCount": 1
    },
    {
        "name": "NEET",
        "_id": "641d732b3df34d4442c50f02",
        "createdAt": "2023-03-24T09:53:47.990Z",
        "updatedAt": "2023-03-24T09:53:47.990Z",
        "__v": 0,
        "positionCount": 27
    },
    {
        "name": "IPE/EMCET",
        "_id": "641d72d53df34d4442c50ed4",
        "createdAt": "2023-03-24T09:52:21.446Z",
        "updatedAt": "2023-03-24T09:52:21.446Z",
        "__v": 0,
        "positionCount": 5
    },
    {
        "name": "CBSE",
        "_id": "641d5c373df34d4442c50c3d",
        "createdAt": "2023-03-24T08:15:51.946Z",
        "updatedAt": "2023-03-24T08:15:51.946Z",
        "__v": 0,
        "positionCount": 4
    },
    {
        "name": "E-Techno",
        "_id": "641d5c1e3df34d4442c50c36",
        "createdAt": "2023-03-24T08:15:26.465Z",
        "updatedAt": "2023-03-24T08:15:26.465Z",
        "__v": 0,
        "positionCount": 1
    },
    {
        "name": "Foundation",
        "_id": "641d5c0d3df34d4442c50c30",
        "createdAt": "2023-03-24T08:15:09.141Z",
        "updatedAt": "2023-03-24T08:15:09.141Z",
        "__v": 0,
        "positionCount": 17
    },
    {
        "name": "Mains",
        "_id": "641bd0a0947f5641ae3da3a6",
        "createdAt": "2023-03-23T04:08:00.441Z",
        "updatedAt": "2023-03-23T04:08:00.441Z",
        "__v": 0,
        "positionCount": 39
    },
    {
        "name": "Advance",
        "_id": "641bc4dd947f5641ae3da246",
        "createdAt": "2023-03-23T03:17:49.535Z",
        "updatedAt": "2023-03-23T03:17:49.535Z",
        "__v": 0,
        "positionCount": 36
    }
]